import { FC } from 'react';
import { FaGlobe } from 'react-icons/fa';
import { HiPlus } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { Button } from '@/lib';

type EmailSendingDomainsEmptyCardProps = {
  onAdd: () => void;
};

export const EmailSendingDomainsEmptyCard: FC<EmailSendingDomainsEmptyCardProps> = ({ onAdd }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-center rounded-2xl border border-secondary-border bg-white px-6 py-16 text-center md:px-10 md:py-20'>
      <div className='flex size-[74px] items-center justify-center rounded-2xl bg-blue-50 text-blue-700'>
        <FaGlobe className='size-8' />
      </div>
      <h2 className='mt-6 text-2xl font-bold text-slate-900 md:text-[23px]'>{t('emailWorkspace.domains.emptyTitle')}</h2>
      <p className='text-secondary-600 mt-2 max-w-xl text-[15px] leading-relaxed'>{t('emailWorkspace.domains.emptyDescription')}</p>
      <Button intent='primary' size='md' className='mt-6 inline-flex items-center gap-2 px-5 py-3' onClick={onAdd}>
        <HiPlus className='size-4' />
        {t('emailWorkspace.domains.addSendingDomain')}
      </Button>
    </div>
  );
};
